import { Table } from "@/components";
import type { PerformanceTabData } from "@/hooks/usePerformanceSectionData";
import { useIsBelow } from "@/styles/breakpoints";
import { useState } from "react";
import DropdownSelect from "../DropdownSelect";
import * as monthStyles from "./MonthlyTab.css";
import * as styles from "./Tables.css";

type Props = {
	data: PerformanceTabData["monthly"];
	styleVariants?: monthStyles.WrapVariants;
};

export default function MonthlyTab({ data, styleVariants }: Props) {
	const isBelowL = useIsBelow("l");
	const [year, setYear] = useState(
		data?.years.at(0) ?? `${(new Date()).getFullYear()}`,
	);
	if (!data) return null;
	return (
		<div className={`${monthStyles.wrap(styleVariants)}`}>
			<div className={monthStyles.selectWrap(styleVariants)}>
				<DropdownSelect
					value={year}
					options={data.years.map((y) => ({ value: y }))}
					onChange={setYear}
					className={monthStyles.select(styleVariants)}
				>
					Select year
				</DropdownSelect>
			</div>
			<Table
				data={data.data[year].data}
				headers={["", ...data.headers]}
				className={`${styles.table} ${monthStyles.table}`}
				scroll={isBelowL}
			/>
		</div>
	);
}
